import { useQuery } from "@tanstack/react-query";
import { useSchools } from "components/FormFields";
import RequestForm from "components/RequestForm/RequestForm";
import { DateTime } from "luxon";
import { RequestDetailsResponse, RequestModel } from "model";

import { Loader } from "~components/Atoms";
import { fetchRequest, useURLSearchParams } from "~utils";

import { copyRequest } from "./utils";

export function RequestASubPage() {
  /*** Hooks ***/
  const searchParams = useURLSearchParams();
  const requestId = searchParams.get("clonedFrom");

  /*** Queries ***/
  const schools = useSchools();
  const { data: request } = useQuery<RequestDetailsResponse>({
    queryKey: ["requests", requestId],
    queryFn: async () => {
      const { data } = await fetchRequest({ requestId: requestId || "" }).then((resp) => resp);
      return data;
    },
    enabled: !!requestId,
  });

  /*** Render ***/
  if (!schools) return <Loader />;

  // return early if there is no request id
  if (!requestId) {
    return (
      <div
        className="page"
        css={{
          paddingTop: 16,
          paddingLeft: 16,
          paddingRight: 16,
          // Increasing the padding bottom since on iOS/Android, with the safe
          // area, there needs more padding so that the button is less close
          // to the bottom screen "---" line
          paddingBottom: 32,
        }}
      >
        <RequestForm mode="create" schools={schools} />
      </div>
    );
  }

  // Render loading icon if we are copying a request but the response isn't ready
  if (!request) return <Loader />;

  /*** Constants ***/
  const Request = new RequestModel(request);
  const school = schools.find((school) => school.id === Request.school.id);

  /*** Render ***/
  return (
    <div
      className="page"
      css={{
        paddingTop: 16,
        paddingLeft: 16,
        paddingRight: 16,
        // Increasing the padding bottom since on iOS/Android, with the safe
        // area, there needs more padding so that the button is less close
        // to the bottom screen "---" line
        paddingBottom: 32,
      }}
    >
      <RequestForm
        mode="create"
        schools={schools}
        request={copyRequest({ request, now: DateTime.now(), school })}
      />
    </div>
  );
}
